var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent-nav"},[_c('div',{staticClass:"sign-out-contol"},[_c('UserControl')],1),(_vm.showSignoutPrompt)?_c('div',{staticClass:"sign-out-prompt"},[_c('SignoutPrompt',{on:{"onCloseSignoutPrompt":_vm.handleCloseSignoutPrompt}})],1):_vm._e(),(_vm.showSignoutPrompt)?_c('div',{staticClass:"overlay"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }